/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptioninen3Inputs */

const en_eventdescriptioninen3 = /** @type {(inputs: Eventdescriptioninen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description in English`)
};

const de_eventdescriptioninen3 = /** @type {(inputs: Eventdescriptioninen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung auf Englisch`)
};

/**
* | output |
* | --- |
* | "Description in English" |
*
* @param {Eventdescriptioninen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptioninen3 = /** @type {((inputs?: Eventdescriptioninen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptioninen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptioninen3(inputs)
	return de_eventdescriptioninen3(inputs)
});
export { eventdescriptioninen3 as "eventDescriptionInEn" }